<template>
  <ActionsMenu>
    <delete-post :post="post" />
    <unreport-post :post="post" />
  </ActionsMenu>
</template>

<script>
import ActionsMenu from '../shared/ActionsMenu'
import DeletePost from './DeletePost'
import UnreportPost from './UnreportPost'

export default {
  name: 'AdminPostActionsMenu',
  components: { ActionsMenu, DeletePost, UnreportPost },
  props: {
    post: {
      type: Object,
      required: true
    }
  }
}
</script>
